import { useMyStore } from "src/components/main/mainStore";
import WorkLogForm from "../workLogForm";
//---------------------------------------------------
export default function LocatingForm({
    ...rest
}){
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const gasLeakSurveyItems = [
        {title: "Job Site Address", type: "text", default: rest.location},
        {title: "Locator Name", type: "text", default: rest.userName ?? user.userName}, 
        {title: "Space Number", type: "text", required: true, docNum: true},
        {title: "Leak", type: "select", required: true, options: ["Yes", "No", "No Access"]},
        {title: "Notes", type: "textarea"}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            picsLimit = {2}
            items = {gasLeakSurveyItems}
            {...rest}
        />
    )    
}